import { Skeleton, notification } from "antd";
import React, { lazy, Suspense, useContext, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { getB2BTokens } from "./AuthService/userData";
import ClaimMessagingView from "./Pages/ClaimMessaging/claimMessagingView";
import HealthCheck from "./HealthCheck";
import EmptyPage from "./Pages/EmptyPage/EmptyPage";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MyContext } from "./mycontext";
import approvalIcon from "./Assets/img/icons/AP.png";
import claimIcon from "./Assets/img/icons/CL.png";
import { io } from "socket.io-client";
import { getBaseUrlB2B } from "./AuthService/BaseURLS";
import MaintainanceScreen from "./Pages/Maintainance/MaintainanceScreen";

const Login = lazy(() => import("./Pages/Login/Login"));
const Dashboard = lazy(() => import("./Pages/Dashboard/Dashboard"));
const Claim = lazy(() => import("./Pages/Claim/Claim"));
const ClaimViewer = lazy(() => import("./Pages/ClaimViewer/ClaimViewer"));
const InPatientViewer = lazy(
  () => import("./Pages/ClaimViewer/InPatientViewer"),
);
const ValidateClaim = lazy(() => import("./Pages/Claim/ValidateClaim"));
const ValidFPOSClaims = lazy(() => import("./Pages/Claim/ValidFPOSClaims"));
const claimDetails = lazy(() => import("./Pages/ClaimViewer/Claimdetails"));
const UnderConstruction = lazy(() => import("./Pages/Settings/settings"));
const BatchClaimPreview = lazy(
  () => import("./Pages/Financial/components/BatchClaimPreview"),
);
const Routes = () => {
  const [api, contextHolder] = notification.useNotification({});
  const [socket, setSocket] = useContext(MyContext);
  const openNotification = ({ title, description, type }) => {
    api.open({
      // message: null,
      description: null,
      message: (
        <div
          className="notification-container"
          style={{
            width: "100%",
            marginRight: "-10px",
            padding: "0",
            border: "none",
          }}
        >
          <div style={{ width: "10%" }}>
            <img
              src={type == "approval" ? approvalIcon : claimIcon}
              alt="icon"
              style={{ width: "100%" }}
            />
          </div>
          <div className="notification-item">
            <div className="notification-header">
              <h6 className="notification-title">{title}</h6>
            </div>
            <p className="notification-desc">{description}</p>
          </div>
        </div>
      ),
      closeIcon: (
        <IoCloseCircleOutline size={24} style={{ color: "#1cc9bc" }} />
      ),
      style: {
        borderRadius: "10px",
        borderBottom: "2px solid #1cc9bc",
        padding: "10px",
        width: "20vw",
      },
      className: "custom-notification",
      duration: null,
      placement: "bottomLeft",
    });
  };
  useEffect(async () => {
    if (getB2BTokens() != null) {
      const socket = io.connect(getBaseUrlB2B(), {
        path: "/messaging",
        auth: {
          token: `Bearer ${getB2BTokens()[0].accessToken}`,
          recipientAppType: "provider",
          payername: getB2BTokens()[0].payerName,
          serverOffset: 0,
        },
      });

      socket.on("reloadApprovals", (msg) => {
        openNotification(msg);
      });
      socket.on("gg", (msg) => {
        openNotification(msg);
      });
      setSocket(socket);
    }
  }, []);

  useEffect(() => {
    return () => {
      socket?.disconnect();
      setSocket(null);
    };
  }, []);

  if (getB2BTokens() != null) {
    return (
      <>
        {contextHolder}
        <Suspense fallback={<Skeleton active />}>
          <Switch>
            <Route exact path="/">
              <Redirect to="/dashboard" />
            </Route>
            <Route exact path="/login">
              <Redirect to="/dashboard" />
            </Route>
            <Route
              exact
              path="/dashboard"
              render={(props) => <Dashboard {...props} />}
            />
            <Route exact path="/Claim" component={Claim} />
            <Route exact path="/refresh/:destination" component={EmptyPage} />
            <Route exact path="/claimviewer" component={ClaimViewer} />
            <Route exact path="/inpatientviewer" component={InPatientViewer} />

            <Route exact path="/healthz" component={HealthCheck} />
            <Route
              exact
              path="/claim/validate"
              component={ValidateClaim}
            ></Route>
            <Route
              exact
              path="/claim/preauthorization"
              component={ValidFPOSClaims}
            ></Route>
            <Route exact path="/claim/detail" component={claimDetails} />
            <Route
              exact
              path="/claim/notification"
              component={ClaimMessagingView}
            />
            <Route exact path="/settings" component={UnderConstruction} />
            {/* <Route exact path="/printcoverletter" component={PrintCoverLetter}/> */}
            {/* <Route exact path="/financial" component={Financial}/> */}
            <Route
              exact
              path="/claimviewer/batch/:id"
              component={BatchClaimPreview}
            />
            {/* <Route  path="*">
              <Redirect to="/dashboard" />
            </Route> */}
          </Switch>
        </Suspense>
      </>
    );
  } else {
    return (
      <Suspense fallback={<p>loading ...</p>}>
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>

          <Route path="/login" component={Login} />
          <Route path="*">
            {" "}
            <Redirect to="/login" />
          </Route>
          {/* <Route  path="*">
            <Redirect to="/select-company" />
          </Route> */}
        </Switch>
      </Suspense>
    );
  }
};
export default Routes;
